import React ,{useState}from 'react';
import Chart from 'react-apexcharts';
import styles from './Chart1.module.css'; // Import the CSS module


function Chart1() {
    const [dropdownOpen, setDropdownOpen] = useState(false);

  const chartOptions = {
    chart: {
      height: 350,
      type: 'line',
      toolbar: {
        show: false
      }
    },
    colors: ['#FF4560', '#D3D3D3'], // Red for line, Light grey for bars
    stroke: {
      width: [4, 0], // Line width for the line series
    },
    dataLabels: {
      enabled: false
    },
    series: [{
      name: 'Stocks sold',
      type: 'line',
      data: [23000, 11000, 22000, 27000, 13000, 22000, 37000, 21000, 44000, 22000, 30000, 25000, 35000]
    }, {
      name: 'Total views',
      type: 'column',
      data: [44000, 55000, 41000, 67000, 22000, 43000, 21000, 49000, 21000, 32000, 41000, 45000, 30000]
    }],
    xaxis: {
      type: 'datetime',
      categories: [
        '2019-06-21', '2019-07-21', '2019-08-21', '2019-09-21', '2019-10-21',
        '2019-11-21', '2019-12-21', '2020-01-21', '2020-02-21', '2020-03-21',
        '2020-04-21', '2020-05-21', '2020-06-21'
      ],
    },
    yaxis: [{
      title: {
        text: 'Stocks sold',
      },
      labels: {
        formatter: (value) => `$${value}k`
      },
    }, {
      opposite: true,
      title: {
        text: 'Total views'
      },
      labels: {
        formatter: (value) => `${value / 1000}k`
      },
    }],
    grid: {
      show: true,
    },
    legend: {
      position: 'top',
      horizontalAlign: 'left',
      offsetX: 40
    },
    plotOptions: {
      bar: {
        columnWidth: '20%', // Adjust to make thinner bars
      }
    },
    tooltip: {
      shared: true,
      intersect: false,
      y: {
        formatter: function (y) {
          if (typeof y !== "undefined") {
            return `$${y}k`;
          }
          return y;
        }
      }
    },
  };
  const handleSelection = (range) => {
    console.log(`Selected range: ${range}`);
    // Logic to update chart data based on the selected range
    // ...
    setDropdownOpen(false); // Close the dropdown
  };


  return (
    <div id="chart">
      {/* Dropdown button */}
      <div style={{ position: 'relative', display: 'flex',justifyContent:"flex-end" }}>
        <button className={`${styles.first}`}
          onClick={() => setDropdownOpen(!dropdownOpen)}
          >
          Last 1 Year ▼
        </button>
        {dropdownOpen && (
          <div className={`${styles.second}`}>
            <a className={`${styles.third}`}
              href="#"
              onClick={() => handleSelection('1 Year')}>
              Last 1 Year
            </a>
            <a
              href="#"
              onClick={() => handleSelection('6 Months')}
              className={`${styles.third}`}>
              Last 6 Months
            </a>
            <a
              href="#"
              onClick={() => handleSelection('3 Months')}
              className={`${styles.third}`}>
              Last 3 Months
            </a>
            <a
              href="#"
              onClick={() => handleSelection('1 Month')}
              className={`${styles.third}`}
              >
              Last 1 Month
            </a>
          </div>
        )}
      </div>

      {/* Chart component */}
      <Chart options={chartOptions} series={chartOptions.series} height={350} />
    </div>
  );
}

export default Chart1;